import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdCustomRolesUpdateCustomRoleIdCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/custom_roles/custom_role_management_data",
  "/companies/:company_id/custom_roles/custom_role/:id",
];
